/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
// @ts-nocheck

import { forwardRef } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import MenuItem from "@mui/material/MenuItem";

// Soft UI Dashboard React components
import SoftBox from "../../common/softBox";
import SoftTypography from "../../common/softTypography";

// custom styles for the NotificationItem
import { menuItem, menuImage } from "./styles";
      //  @ts-ignore  

const NotificationItem = forwardRef(({ color, image, title, date, ...rest }, ref) => (
      //  @ts-ignore  

  <MenuItem {...rest} ref={ref} sx={(theme) => menuItem(theme)}>
        {/* @ts-ignore   */}

    <SoftBox
      minWidth="2.25rem"
      height="2.25rem"
      mt={0.25}
      mr={2}
      mb={0.25}
      borderRadius="lg"
      //  @ts-ignore  

      sx={(theme) => menuImage(theme, { color })}
    >
      {image}
    </SoftBox>
      {/* @ts-ignore   */}

    <SoftBox>
    {/* @ts-ignore   */}

      <SoftTypography variant="button" textTransform="capitalize" fontWeight="regular">
        <strong>{title[0]}</strong> <span> {title[1]?.split(" ").slice(0, 5).join(" ")}...</span>
      </SoftTypography>
      {/* @ts-ignore   */}

      <SoftTypography
        variant="caption"
        color="secondary"
        sx={{
          display: "flex",
          alignItems: "center",
          mt: 0.5,
        }}
      >
     {/* @ts-ignore   */}

        <SoftTypography variant="button" color="secondary">
          {/* <Icon
            sx={{
              lineHeight: 1.2,
              mr: 0.5,
            }}
          >
            watch_later
          </Icon> */}
        </SoftTypography>
        {date}
      </SoftTypography>
    </SoftBox>
  </MenuItem>
));

// Setting default values for the props of NotificationItem
      //  @ts-ignore  

NotificationItem.defaultProps = {
      //  @ts-ignore  

  color: "dark",
};

// Typechecking props for the NotificationItem
NotificationItem.propTypes = {
      //  @ts-ignore  

  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  image: PropTypes.node.isRequired,
  title: PropTypes.arrayOf(PropTypes.string).isRequired,
  date: PropTypes.string.isRequired,
};

export default NotificationItem;
